module.exports = __webpack_public_path__ + "img/hr-branch-particle-17.91eed618.png";